module.exports = __webpack_public_path__ + "static/media/sign_up_poster.acab90db.jpeg";